import { useEffect } from 'react';

import { Button } from '@sravni/react-design-system/lib/Button';
import { Carousel } from '@sravni/react-design-system/lib/Carousel';
import { Icon } from '@sravni/react-design-system/lib/Icon';
import { ArrowRight } from '@sravni/react-icons';

import { CbSvgIcon } from '@src/components/icons/CbSvgIcon';
import { EsiaSvgIcon } from '@src/components/icons/EsiaSvgIcon';
import { PhoneSvgIcon } from '@src/components/icons/PhoneSvgIcon';
import { SecuritySvgIcon } from '@src/components/icons/SecuritySvgIcon';
import {
  sendYmylHowToGetLoanView,
  sendYmylLicensedPlatformClick,
  sendYmylLicensedPlatformView,
} from '@src/helpers/analyticsEvents';
import { syntheticOpen, WindowTargets } from '@src/helpers/synteticOpen';
import { isServer } from '@src/utils';

import { SeoGuideCard } from '../SeoGuideCard/SeoGuideCard';

import styles from './SeoFinanceCarousel.module.scss';

export const CB_MFO_LINK_URL =
  'https://cbr.ru/finorg/?fo_SearchPrase=&fo_orgType=&fo_foStatus=1&fo_foOkato=&fo_Vidid=11&fo_WithFilials=false&fo_WithAddr=false#datares';

const CONTENT = [
  {
    id: '1',
    title: 'Защита данных',
    description:
      'Регулярный аудит информационной безопасности. Все данные передаются в зашифрованном виде. Включены в реестр операторов персональных данных Роскомнадзора.',
    icon: <SecuritySvgIcon />,
  },
  {
    id: '2',
    title: 'Безопасно на высшем уровне',
    description: 'Интеграция с государственной платформой Госуслуг.',
    icon: <EsiaSvgIcon id="esia-icon-2" />,
  },
  {
    id: '3',
    title: 'Оформление онлайн',
    description:
      'Оформляйте кредит или займ напрямую через финансовую платформу Сравни.ру — без посещения сторонних сайтов.',
    icon: <PhoneSvgIcon />,
  },
  {
    id: '4',
    title: 'МФО в реестре ЦБ РФ',
    description: 'Все МФО из списка внесены в Реестр субъектов рынка микрофинансирования ЦБ РФ.',
    icon: <CbSvgIcon />,
    actions: (
      <Button
        size={52}
        color="blue"
        variant="text"
        className={styles.button}
        onClick={() => {
          sendYmylLicensedPlatformClick();
          syntheticOpen({
            href: CB_MFO_LINK_URL,
            target: WindowTargets.BLANK_NO_OPENER,
          });
        }}
      >
        Проверьте по ссылке
        <Icon icon={<ArrowRight />} />
      </Button>
    ),
  },
];

export function SeoFinanceCarousel() {
  useEffect(() => {
    if (isServer) return;
    sendYmylLicensedPlatformView();
  }, []);

  return (
    <Carousel gap={16} className={styles.container}>
      {CONTENT.map((item) => (
        <SeoGuideCard key={item.id} {...item} />
      ))}
    </Carousel>
  );
}
